import React, { useContext } from 'react'
import { FormContext } from '../../FormContext'

import StepPersonalInformation from '../../steps/contact/StepPersonalInformation'
import StepSuccess from '../../steps/contact/StepSuccess'
import StepFailed from '../../steps/contact/StepFailed'
  
const FormContact: React.FC = () => {
    const context = useContext(FormContext);
  
    if (!context) {
      throw new Error("Form must be used within a FormContextProvider");
    }
  
    const {
        stepPersonalInformation,
        stepSuccess,
        stepFailed
    } = context;

    const setStepPage = (() => {
        if (stepPersonalInformation) {
            return <StepPersonalInformation /> 
        } else if (stepSuccess) {
            return <StepSuccess />
        } else if (stepFailed) {
            return <StepFailed />
        }
    })

    return (
        <div className='flex justify-center md:h-screen'>
            <div className='flex my-auto flex-col md:flex-row gap-12 bg-white md:p-4 rounded-xl sm:w-11/12 md:w-4/5 xl:w-2/5'>
                {
                    setStepPage()
                }
            </div>
        </div>
    )
}

export default FormContact